import { render } from "./upgrade-header.vue?vue&type=template&id=ec72c398"
import script from "./upgrade-header.vue?vue&type=script&lang=js"
export * from "./upgrade-header.vue?vue&type=script&lang=js"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__